var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgQuote(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 47,
    viewBox: "0 0 64 47",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.75 27H4.5C3.83696 27 3.20108 26.7367 2.73224 26.2677C2.26339 25.7989 2 25.1631 2 24.5V4.5C2 3.83693 2.26339 3.20107 2.73224 2.73227C3.20108 2.26333 3.83696 2 4.5 2H23.25C23.9131 2 24.5489 2.26333 25.0177 2.73227C25.4867 3.20107 25.75 3.83693 25.75 4.5V32C25.75 35.3152 24.4331 38.4947 22.0888 40.8388C19.7447 43.1831 16.5652 44.5 13.25 44.5",
    stroke: "white",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M62 27H40.75C40.0869 27 39.4511 26.7367 38.9823 26.2677C38.5133 25.7989 38.25 25.1631 38.25 24.5V4.5C38.25 3.83693 38.5133 3.20107 38.9823 2.73227C39.4511 2.26333 40.0869 2 40.75 2H59.5C60.1631 2 60.7989 2.26333 61.2677 2.73227C61.7367 3.20107 62 3.83693 62 4.5V32C62 35.3152 60.6831 38.4947 58.3388 40.8388C55.9947 43.1831 52.8152 44.5 49.5 44.5",
    stroke: "white",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuote);
export default __webpack_public_path__ + "static/media/quote.3e468ec1ecb2d8ade257f11d8b3ef27b.svg";
export { ForwardRef as ReactComponent };